import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { EventBus } from "./plugins/event-bus.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeId: null,
    menuVisible: false,
    photos: [],
    activePhotos: [],
    activeDescription: "",
    societyBoard: [],
  },
  getters: {
    getAllActiveImages(state) {
      if (state.activePhotos.length !== 0) {
        let largeImages = state.activePhotos.map(image => image.full_image_url);
        EventBus.$emit("scroll");
        return { full: state.activePhotos, largeImages };
      }
      EventBus.$emit("scroll");
      return { full: state.activePhotos, largeImages: [] };
    },
    getDescription(state) {
      return state.activeDescription;
    },
    getSocietyBoard(state) {
      return state.societyBoard;
    }
  },
  actions: {
    toggleMenu(context) {
      return context.commit("TOGGLE_HAMBURGER_MENU");
    },
    hideMenu(context) {
      return context.commit("HIDE_HAMBURGER_MENU");
    },
    fetchGalleryPhotos(context, postId) {
      const api = "https://admin.krynolina.org/wp-json";

      axios
        .all([
          axios.get(`${api}/acf/v3/pages/${postId}/Photos?type=photo_gallery`),
          axios.get(`${api}/acf/v3/pages/${postId}`)
        ])
        .then(
          axios.spread((gallery, desc) => {
            const data = {
              postId,
              photos: gallery.data
            };
            context.commit("ADD_PHOTOS", { postId, data });
          })
        );
    },
    changeActiveYearId({ commit, state }, newId) {
      let active = state.photos.find(img => {
        return img.postId === newId;
      });
      return commit("UPDATE_ID", { newId, active });
    },
    resetActive({ commit }) {
      return commit("RESET_ACTIVE");
    },
    activeDesc({ commit }, data) {
      return commit("CHANGE_DESC", data);
    },
    async fetchSocietyBoard(context) {
      const api = "https://admin.krynolina.org/wp-json";

      await axios.get(`${api}/wp/v2/society_board`)
        .then(response => {
            const content = response.data.length > 0 
              ? response.data[0].content.rendered
                .match(/<li>([^<]+)<\/li>/g)
                .map(match => match.replace(/<\/?li>/g, '').trim())
              : [];
            context.commit("SET_SOCIETY_BOARD", content);
        })
    },
  },
  mutations: {
    TOGGLE_HAMBURGER_MENU(state) {
      return (state.menuVisible = !this.state.menuVisible);
    },
    HIDE_HAMBURGER_MENU(state) {
      return (state.menuVisible = false);
    },
    ADD_PHOTOS(state, { postId, data }) {
      state.activePhotos = data.photos;
      state.activeId = postId;
      state.photos.push(data);
    },
    UPDATE_ID(state, { newId, active, desc }) {
      state.activeId = newId;
      state.activePhotos = active.photos;
    },
    RESET_ACTIVE(state) {
      (state.activeDescription = ""),
        (state.activePhotos = ""),
        (state.activeId = "");
    },
    CHANGE_DESC(state, data) {
      state.activeDescription = data;
    },
    SET_SOCIETY_BOARD(state, payload) {
      state.societyBoard = payload
    }
  }
});
